import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
//import rnd from 'react-rnd';
import { Rnd } from 'react-rnd';
import html2canvas from 'html2canvas'
import { refStorageTemp } from "../config/firebase";
//import { getMenu,getProducto,ponesacaProducto,cambiaGal } from '../actions'


class Custom extends Component{

	constructor(props) {
    super(props);
    this.state = {
      imgPrefix:"",
      resultado:"",
      fondocolor:"#ffffff",
      select:-1,
      formAct:1,
      formTexto:"active",
      formFoto:"",
      formTrama:"",
      printArea:{
        width_cont: 1024,
        heigth_cont: 152,
        image:"imgs/TyvekNaranjaFluo.png",
        width: '412px',
        height: '56px', 
        marginLeft:'133px',
        marginTop:'48px'
      },
      objeto:{
        tipo:1,
        back:"",
        fuente:"",
        contenido:"",
        color:"#000000",
        tamano:28,
        x:0,
        y:0,
        w:150,
        h:50
      },
      objetos:[
       /* {
          tipo:1,
          back:"",
          fuente:"Oswald",
          contenido:"Test 2",
          color:"#000000",
          tamano:14,
          x:0,
          y:0,
          w:150,
          h:50
        },
        {
          tipo:2,
          back:"",
          fuente:"/imgs/fotos/clash.jpg",
          contenido:"Test 2",
          color:"#000000",
          tamano:14,
          x:0,
          y:0,
          w:150,
          h:50
        }*/
      ]
    }
    
    this.agregaObjeto = this.agregaObjeto.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleChange2 = this.handleChange2.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.traeObjeto = this.traeObjeto.bind(this)
    this.agregaObjeto = this.agregaObjeto.bind(this)
    this.actualizaObjeto = this.actualizaObjeto.bind(this)
    this.borraObjeto = this.borraObjeto.bind(this)
    this.capturaCustom = this.capturaCustom.bind(this)
    this.uploadFile = this.uploadFile.bind(this)
    this.cambiaForm = this.cambiaForm.bind(this)
    this.cambiaPulsera = this.cambiaPulsera.bind(this)
  }
	   
  componentDidMount() {
    console.log(this.props.tipo)
  }

  traeObjeto(){
    
  }

  cambiaPulsera(e){
    var data={}
    if(e.target.value=="1"){
      data={
        width_cont: 1024,
        heigth_cont: 152, 
        image:"imgs/TyvekNaranjaFluo.png",
        width: '412px',
        height: '56px', 
        marginLeft:'133px',
        marginTop:'48px'
      }
    }else if(e.target.value=="2"){
      data={
        width_cont: 1024,
        heigth_cont: 152, 
        image:"imgs/PlasticoRojo.png",
        width: '400px',
        height: '48px', 
        marginLeft:'167px',
        marginTop:'82px'
      }
    }else if(e.target.value=="3"){
      data={
        width_cont: 1024,
        heigth_cont: 152, 
        image:"imgs/PlasticoGrandeAzulFluo.png",
        width: '204px',
        height: '95px', 
        marginLeft:'170px',
        marginTop:'40px'
      }
    }else if(e.target.value=="4"){
      data={
        width_cont: 810,
        heigth_cont: 460, 
        image:"imgs/Entrada110Amarilla_SU.png",
        width: '590px',
        height: '150px', 
        marginLeft:'110px',
        marginTop:'160px'
      }
    }
    this.setState({printArea:data})
  }

  uploadFile(tipo){
    const file = document.querySelector('#archivo'+tipo).files[0];
    const name = (+new Date()) + '-' + file.name;
    const metadata = { contentType: file.type };
    const task = refStorageTemp.child(name).put(file, metadata);
    task
    .then(snapshot => snapshot.ref.getDownloadURL())
    .then(url => {
      console.log(url)
      var objetos = Object.assign(this.state.objetos); 
      var newObj= {
          tipo:tipo,
          back:"",
          fuente:url,
          contenido:"",
          color:"#000000",
          tamano:16,
          x:0,
          y:0,
          w:150,
          h:50
        }
      if(tipo==1){
        newObj.fuente=""
        newObj.back=url
      }

      objetos.push(newObj)
      this.setState({objetos})
    }).catch((error) => {
      console.log(error.code)
      switch (error.code) {
        case 'storage/unauthorized':
          break;
        case 'storage/canceled':
          break;
        case 'storage/unknown':
          break;
      }
    });
  }

  agregaObjeto(){
    var objetos = Object.assign(this.state.objetos);
    objetos.push(this.state.objeto)
    this.setState({objetos})
  }

  actualizaObjeto(){
    
  }

  borraObjeto(){
    var objetos = Object.assign(this.state.objetos); 
    objetos.splice(this.state.select, 1);
    if(objetos.length>0){
      this.setState({objetos,select: -1});
    }else{
      this.setState({select: -1});
    }
  }

  capturaCustom(){
    console.log("CAPTURA")
    html2canvas(document.querySelector("#canva")).then(canvas => {
        let imgData = canvas.toDataURL('image/png');
        this.setState({resultado:imgData})
    });
  }

  componentDidUpdate(prevProps, prevState){

  }

  handleChange(event) {
    var objetos = Object.assign(this.state.objetos); 
    if(event.target.name=="contenido"){
      objetos[this.state.select][event.target.name] =event.target.value;
    }else{
      objetos[this.state.select][event.target.name] =event.target.value; 
    }
    this.setState({ objetos });
  }

  handleChange2(event) {
    console.log(event.target.name+">"+event.target.value)
    var objeto = this.state.objeto
    objeto[event.target.name]=event.target.value
    this.setState({ objeto });
  }

  handleSubmit(event) {
    var objetos = Object.assign(this.state.objetos);
    objetos.push(this.state.objeto)
    this.setState({objetos})
    event.preventDefault();
  }

  cambiaForm(e){
    console.log(e.target)
    if(e.target.name=="texto"){
      this.setState({formAct:1,formTexto:"active",formFoto:"",formTrama:""})
    }else if(e.target.name=="trama"){
      this.setState({formAct:3,formTexto:"",formFoto:"",formTrama:"active"})
    }else if(e.target.name=="foto"){
      this.setState({formAct:2,formTexto:"",formFoto:"active",formTrama:""})
    }
    e.preventDefault()
  }

/*
            <li className="nav-item">
              <a className={"nav-link "+this.state.formTrama} href="#" name="trama" onClick={this.cambiaForm}>TRAMA</a>
            </li>
            */
  render() {
    const  objetos = this.state.objetos.map((objeto,i)=>{
      var tamano=parseInt(this.state.objetos[i].tamano)
        if(objeto.tipo==1){
          return (
            <Rnd
              default={{
                x: 10,
                y: 10,
                width: 300,
                height: 60,
              }}
              minWidth={2}
              minHeight={2}
              bounds="parent"
              onDragStart={()=>{this.setState({select:i})}}
              key={i}
            >
              <div style={{border: '1px dotted #ddd',margin: 0, height: '100%',backgroundImage:this.state.objetos[i].back}}  className="imgCustomApp">
                <h2 className="sinBlend" style={{fontSize:parseInt(this.state.objetos[i].tamano),color:this.state.objetos[i].color,fontFamily:this.state.objetos[i].fuente}}  dangerouslySetInnerHTML={{__html:this.state.objetos[i].contenido.replace(/\r?\n/g, '<br />')}}></h2> 
              </div>
            </Rnd>
          )
        }else if(objeto.tipo==2){
          return (
            <Rnd
              default={{
                x: 10,
                y: 10,
                width: 300,
                height: 60,
              }}
              minWidth={2}
              minHeight={2}
              bounds="parent"
              onDragStart={()=>{this.setState({select:i})}}
              key={i}
            >
              <div style={{border: '1px dotted #ddd',margin: 0, height: '100%', backgroundImage:this.state.objetos[i].back}} className="imgCustomApp">
                <img src={this.state.objetos[i].fuente} style={{width:'100%', height:"100%"}} className="imgCustomApp"/>
              </div>
            </Rnd>
          )
        }
      })


    return (
      <section className="container-fluid mb-5 sombraHead mt-3 clearfix" >

        <section style={{backgroundImage:'url('+this.state.printArea.image+')',width:this.state.printArea.width_cont,height:this.state.printArea.heigth_cont, marginTop:60, marginBottom:30,paddingTop:this.state.printArea.marginTop }} id="canva" className="backCustomApp ">
          <section  style={{
              width: this.state.printArea.width,
              height: this.state.printArea.height, 
              marginLeft:this.state.printArea.marginLeft
            }} className="backCustomApp printArea">
            {objetos}
          </section>
        </section>

       <section>
          <form>
          <div className="form-row mb-3">
            <div className="col"> 
                <label>FONDO</label>           
                <select className="form-control" name="color" onChange={ this.cambiaPulsera }>
                  <option value="1">Tyvek</option>
                  <option value="2">Plastico</option>
                  <option value="3">PlasticoAncha</option>
                  <option value="4">Entrada</option>
                </select>
              </div>
              </div>
          </form>
        </section>

       <section>
          <form>
          <div className="form-row mb-3">
            <div className="col"> 
                <label>FONDO</label>           
                <select className="form-control" name="color" value={this.state.fondocolor} onChange={ (e)=>{this.setState({fondocolor:e.target.value}) }}>
                  <option value="#0000FF">AZUL</option>
                  <option value="#32CD32">VERDE</option>
                  <option value="#FF0000">ROJO</option>
                  <option value="#ffd700">DORADO</option>
                  <option value="#C0C0C0">PLATEADO</option>
                  <option value="#FFFFFF">BLANCO</option>
                  <option value="#000000">NEGRO</option>
                </select>
              </div>
              </div>
          </form>
        </section>

        { this.state.select>-1 ?

        <section>


        <form>
         <div className="form-row">
            <div className="col">
              <button type="button" className="btn btn-primary" onClick={()=>{this.setState({ select:-1}) }} >NUEVO ELEMENTO</button>
            </div>
            <div className="col">
              <button type="button" className="btn btn-danger" onClick={this.borraObjeto} >BORRA ELEMENTO</button>  
            </div>
          </div>
          <div className="form-group">
            <label>Texto</label>
            <textarea className="form-control" name="contenido" value={this.state.objetos[this.state.select].contenido} onChange={this.handleChange} />
            </div>
            <div className="form-row">
              <div className="col">    
                <label>TIPOGRAFIA</label>        
                <select className="form-control" name="fuente" value={this.state.objetos[this.state.select].fuente} onChange={this.handleChange}>
                  <option value='Noto Serif KR'>Noto Serif KR</option>
                  <option value='Oswald'>Oswald</option>
                  <option value='Roboto Slab'>Roboto Slab</option>
                  <option value='Lobster'>Lobster</option>
                  <option value='Pacifico'>Pacifico</option>
                </select>
              </div>
              <div className="col">
              <label>TAMAÑO</label>
              <input className="form-control" name="tamano" type="number"  value={this.state.objetos[this.state.select].tamano} onChange={this.handleChange} />
              </div>
              <div className="col"> 
                <label>COLOR</label>           
                <select className="form-control" name="color" value={this.state.objetos[this.state.select].color} onChange={this.handleChange}>
                  <option value="#1b98e4">AZUL</option>
                  <option value="#ff6600">VERDE</option>
                  <option value="#d62737">ROJO</option>
                  <option value="#000000">NEGRO</option>
                </select>
              </div>
            </div>
          </form>

        </section>
:
        <section>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a className={"nav-link "+this.state.formTexto} href="#" name="texto" onClick={this.cambiaForm}>TEXTO</a>
            </li>
            <li className="nav-item">
              <a className={"nav-link "+this.state.formFoto} href="#" name="foto" onClick={this.cambiaForm}>FOTO</a>
            </li>
          </ul>

          { this.state.formAct==3 &&
          <form>
            <label>TRAMA</label>
            <input type="file" id="archivo1" className="form-control" />
            <button type="button" className="btn btn-primary" onClick={(e)=>this.uploadFile(1)} >SUBIR</button>
          </form>
          }

          { this.state.formAct==2 &&
          <form>
            <label >FOTO</label>
            <input type="file" id="archivo2" className="form-control" />
            <button type="button" className="btn btn-primary" onClick={(e)=>this.uploadFile(2)} >SUBIR</button>
          </form>
          }

          { this.state.formAct==1 &&
          <form onSubmit={this.handleSubmit} id="textoForm">
            <div className="form-group">
              <label >Texto</label>
              <textarea className="form-control" name="contenido" value={this.state.objeto.contenido} onChange={this.handleChange2} />
            </div>

            <div className="form-row">
              <div className="col">     
              <label>TIPOGRAFIA</label>       
              <select className="form-control" name="fuente" value={this.state.objeto.fuente} onChange={this.handleChange2}>
                <option value='Noto Serif KR'>Noto Serif KR</option>
                <option value='Oswald'>Oswald</option>
                <option value='Roboto Slab'>Roboto Slab</option>
                <option value='Lobster'>Lobster</option>
                <option value='Pacifico'>Pacifico</option>
              </select>
              </div>
              <div className="col">
              <label>TAMAÑO</label>
              <input className="form-control" name="tamano" type="number"  value={this.state.objeto.tamano} onChange={this.handleChange2} />
              </div>
              <div className="col"> 
              <label>COLOR</label>           
                <select className="form-control" name="color" value={this.state.objeto.color} onChange={this.handleChange2}>
                  <option value="#1b98e4">AZUL</option>
                  <option value="#ff6600">VERDE</option>
                  <option value="#d62737">ROJO</option>
                  <option value="#000000">NEGRO</option>
                </select>
              </div>
            </div>
            <button type="submit" className="btn btn-primary" >AGREGAR</button>
          </form>
        
        }
        </section>
}
        <div className="row  mt-3">
          <div className="col">
            <button type="button" className="btn btn-primary" onClick={this.capturaCustom} >GENERAR</button>
          </div>
          { this.state.resultado !="" &&
          <div className="col">
            <a href={this.state.resultado} className="btn btn-primary" >DESCARGAR</a>
          </div>
          }
        </div>

        <div className="clearfix  mt-3">
        <img src={this.state.resultado} />
        </div>
      </section>

    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
      productos: state.productos
    }
}

/*
const mapDispatchToProps = dispatch => {
  return {
    getMenu: (sector) => {
      dispatch(getMenu(sector))
    },
    getProducto: (id) => {
      dispatch(getProducto(id))
    },
    ponesacaProducto: (item, cantidad) =>{
      console.log("PONESACA")
      dispatch(ponesacaProducto(item, cantidad))
    },
    cambiaGal:(galeria) => {
      dispatch(cambiaGal(galeria))
    }
  }
}
*/

export default connect(
  mapStateToProps,
  null
)(Custom)




// WEBPACK FOOTER //
// ./src/containers/custom.js